var _excluded = ["className", "onClick", "tag"];
import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import classnames from 'classnames';
import React from 'react';
/**
 * Accessible generic container component that responds to click events
 * */

var ClickableContainer = function ClickableContainer(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      props = _objectWithoutProperties(_ref, _excluded);

  var onKeyPress = function onKeyPress(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(e);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tag, _extends({
    tabIndex: 0,
    onClick: onClick,
    onKeyPress: onKeyPress,
    role: "button"
  }, props, {
    className: "jsx-1135919111" + " " + (classnames('rg-ClickableContainer', className) || "")
  })), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1135919111"
  }, ".rg-ClickableContainer.jsx-1135919111:focus{outline:thin dotted;}"));
};

ClickableContainer.displayName = 'ClickableContainer';
export default ClickableContainer;